import { HiOutlineExclamationTriangle } from "react-icons/hi2";

import Modal from "../modal/Modal";

import "./ConfirmModal.css";

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,

  title = "Bevestiging vereist",

  message = "Weet je zeker dat je deze actie wilt uitvoeren?",

  confirmText = "Bevestigen",

  cancelText = "Annuleren",

  variant = "danger",

  isLoading = false,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="confirm-modal">
        {/* ICON */}
        <div className={`confirm-modal__icon confirm-modal__icon--${variant}`}>
          <HiOutlineExclamationTriangle />
        </div>

        {/* CONTENT */}
        <div className="confirm-modal__content">
          <h2>{title}</h2>

          <p>{message}</p>
        </div>

        {/* ACTIONS */}
        <div className="confirm-modal__actions">
          <button
            type="button"
            className="confirm-modal__cancel"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelText}
          </button>

          <button
            type="button"
            className={`confirm-modal__confirm confirm-modal__confirm--${variant}`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Bezig..." : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
